/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo } from "react";
import { When } from "react-if";
import { Link } from "react-router-dom";
import { theme } from "@nordcloud/gnui";
import { type ResourceExecutionErrorCodeCount } from "~/generated/graphql";
import { LOG_RELATED_ERROR_CODES } from "~/constants";
import { EventResourceExecutionErrorMessage } from "./EventResourceExecutionErrorMessage";

type Props = {
  errorCodeCounts: ResourceExecutionErrorCodeCount[];
};

export function EventResourceExecutionErrorMessages({
  errorCodeCounts,
}: Props) {
  const errorCodes = useMemo(() => {
    const activeCodes = new Set(
      errorCodeCounts
        .filter(({ count }) => count > 0)
        .map(({ errorCode }) => errorCode)
    );

    return LOG_RELATED_ERROR_CODES.filter((errorCode) =>
      activeCodes.has(errorCode)
    );
  }, [errorCodeCounts]);

  return (
    <When condition={errorCodes.length > 0}>
      <div css={{ marginBottom: theme.spacing.spacing04 }}>
        {errorCodes.map((errorCode) => (
          <EventResourceExecutionErrorMessage
            key={errorCode}
            errorCode={errorCode}
            subtitle={
              <>
                Switch to report view for details and check{" "}
                <Link
                  to={{
                    pathname:
                      "https://docs.fleetcontrol.nordcloudapp.com/docs/troubleshooting#possible-causes-and-remedies",
                  }}
                  target="_blank"
                  rel="noreferrer"
                  css={{
                    color: theme.color.support.blue,
                    fontWeight: theme.fontWeights.medium,
                    textDecoration: "none",
                  }}
                >
                  documentation
                </Link>
              </>
            }
          />
        ))}
      </div>
    </When>
  );
}
